import sidePanel from 'side-panel-menu-thing'
import BigPicture from 'bigpicture'
import Popup from '../components/popup.svelte'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const { $, boostPopupOptions } = window

const $body = $(document.body)

export default {
	init() {
		// JavaScript to be fired on all pages
		const mobileMenu = new sidePanel({
			target: $body[0],
			props: {
				target: $body[0],
				content: document.getElementById('menu'),
				fixed: true,
				width: 320,
			},
		})
		$('#toggle_nav').on('click', mobileMenu.show)

		$(document).on(
			'click',
			'.menu-section .menu-item-has-children > a',
			function (e) {
				e.preventDefault()
				let $el = $(this)
				$el.parent().toggleClass('show-subnav')
			}
		)

		//animation / gsap
		//hero
		let $heroP = $('.wp-block-group__inner-container > p')[0]
		if ($heroP) {
			gsap.fromTo(
				'.wp-block-group__inner-container > p',
				{
					x: -50,
					opacity: 0,
				},
				{
					scrollTrigger: '.wp-block-group__inner-container > p',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}
		let $heroH1 = $('.wp-block-group__inner-container > h1')[0]
		if ($heroH1) {
			gsap.fromTo(
				'.wp-block-group__inner-container > h1',
				{
					x: 50,
					opacity: 0,
				},
				{
					scrollTrigger: '.wp-block-group__inner-container > h1',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}

		//coastal text & media block
		let $oddMediaBlock = $(
			'.inner-content-wrap .coastal-text-media-block:nth-of-type(odd)'
		)
		if ($oddMediaBlock.length) {
			document
				.querySelectorAll(
					'.inner-content-wrap .coastal-text-media-block:nth-of-type(odd)'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: -50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}

		let $evenMediaBlock = $(
			'.inner-content-wrap .coastal-text-media-block:nth-of-type(even)'
		)
		if ($evenMediaBlock.length) {
			document
				.querySelectorAll(
					'.inner-content-wrap .coastal-text-media-block:nth-of-type(even)'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}

		//default blocks
		let $galleryBlock = $('.wp-block-gallery')
		if ($galleryBlock.length) {
			document.querySelectorAll('.wp-block-gallery').forEach((item) => {
				gsap.fromTo(
					item,
					{ y: 15, opacity: 0 },
					{
						scrollTrigger: item,
						delay: 0.5,
						duration: 0.5,
						y: 0,
						opacity: 1,
					}
				)
			})
		}

		//cta
		let $cta = $('.cta')[0]
		if ($cta) {
			gsap.fromTo(
				'.cta > img',
				{
					y: -50,
					opacity: 0,
				},
				{
					scrollTrigger: '.cta > img',
					delay: 0.5,
					duration: 0.5,
					y: 0,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'.cta > h2',
				{
					x: -50,
					opacity: 0,
				},
				{
					scrollTrigger: '.cta > h2',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'.cta > h3',
				{
					x: 50,
					opacity: 0,
				},
				{
					scrollTrigger: '.cta > h3',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
			gsap.fromTo(
				'.cta > .btn',
				{
					y: 50,
					opacity: 0,
				},
				{
					scrollTrigger: '.cta > .btn',
					delay: 0.5,
					duration: 0.5,
					y: 0,
					opacity: 1,
				}
			)
		}
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		let $article = $('article.main-content')

		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		// article enlarge images
		if ($article.length) {
			$article
				.find(
					'.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".jpeg"]'
				)
				.on('click', function (e) {
					const $this = $(this)
					const $imgEls = $this.find('img')
					e.preventDefault()
					BigPicture({
						el: $imgEls.length ? $imgEls[0] : this,
						imgSrc: this.href,
					})
				})
		}

		let $blocksGallery = $('.blocks-gallery-item > figure > a')
		if ($blocksGallery.length) {
			let $caption = $('.blocks-gallery-item__caption')
			if ($caption) {
				$caption.each(function () {
					$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
				})
			}

			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
				})
			})
		}

		let $wpBlockImg = $('.wp-block-image')
		if ($wpBlockImg.length) {
			$wpBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}

		let $wpMediaTxtBlockImg = $('.wp-block-media-text__media')
		if ($wpMediaTxtBlockImg.length) {
			$wpMediaTxtBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}

		let $coastalTextBlock = $('.coastal-img:not(.sen-item-image)')
		if ($coastalTextBlock.length) {
			let $caption = $('.coastal-img-caption p')
			if ($caption) {
				$caption.each(function () {
					$(this)
						.parent()
						.parent()
						.find('.coastal-img')[0]
						.setAttribute('data-caption', $(this).text())
				})
			}
			$coastalTextBlock.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
				})
			})
		}

		let $singleImage = $('.single-image')
		if ($singleImage.length) {
			$singleImage.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
				})
			})
		}

		if (boostPopupOptions) {
			new Popup({
				target: document.body,
				props: {
					options: boostPopupOptions,
				},
			})
		}
	},
}
